import { render, staticRenderFns } from "./PagePermissionDenied.vue?vue&type=template&id=5c5fe1e6&"
import script from "./PagePermissionDenied.vue?vue&type=script&lang=js&"
export * from "./PagePermissionDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports